import * as tslib_1 from "tslib";
import { BaseComponent } from "../../../../base/base.component";
import { FormInfo } from "../../../../../crossconcern/models/form/forminfo";
import { AppComponent } from "../../../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { GenericService } from "../../../../../crossconcern/services/generic.services";
import { AlertUtils } from "../../../../../crossconcern/utilities/utils/alert.utils";
import { FormInfoField } from "../../../../../crossconcern/models/form/forminfofield";
import { FORM_TYPE_CHECKBOX, FORM_TYPE_FILE, FORM_TYPE_MULTISELECT, FORM_TYPE_TEXT, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0 } from "../../../../../crossconcern/utilities/properties/base.property";
import { Validators } from "@angular/forms";
import { PRIVATE_PROMOTION_LIST_ROUTE } from "../../../../../crossconcern/utilities/properties/routename.property";
import { PhotosphereManager } from "../../../../../business/managers/photosphere.manager";
import { concatMap, finalize, map } from "rxjs/operators";
import { NurseryManager } from "app/business/managers/nursery.manager";
var PromotionEditComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PromotionEditComponent, _super);
    function PromotionEditComponent(appComponent, router, location, genericService, photosphereManager, nurseryManager, activeRoute, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.genericService = genericService;
        _this.photosphereManager = photosphereManager;
        _this.nurseryManager = nurseryManager;
        _this.activeRoute = activeRoute;
        _this.alertUtils = alertUtils;
        _this.selectedFiles = [];
        _this.titleText = "PROMOTION_EDIT_COMPONENT_LABEL";
        _this.dropdownSettings = {
            singleSelection: false,
            idField: "id",
            textField: "text",
            enableCheckAll: false,
            allowSearchFilter: true
        };
        var formInfoFields = [
            new FormInfoField(FORM_TYPE_TEXT, "PROMOTION_EDIT_COMPONENT_NAME", "name", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_TEXT, "PROMOTION_EDIT_COMPONENT_DESC", "desc", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_MULTISELECT, "PROMOTION_EDIT_COMPONENT_PRODUCTS", "products", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0, null, null, null, null, _this.dropdownSettings),
            new FormInfoField(FORM_TYPE_MULTISELECT, "PROMOTION_EDIT_COMPONENT_NURSERIES", "nurseries", [
                Validators.required
            ], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0, null, null, null, null, _this.dropdownSettings),
            new FormInfoField(FORM_TYPE_CHECKBOX, "PROMOTION_COMPONENT_FEATURED", "featured", [], null, null, null, true, false, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0),
            new FormInfoField(FORM_TYPE_FILE, "PROMOTION_COMPONENT_IMAGE", "image", [], null, null, null, true, true, null, FORM_WIDTH_COL_4, FORM_WIDTH_OFFSET_COL_0, undefined, undefined, ".jpg,.jpeg,.png", true)
        ];
        _this.formInfo = new FormInfo(formInfoFields, null);
        _this.subscribeGenericServices();
        return _this;
    }
    PromotionEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activeRoute.params.subscribe(function (params) {
            if (params.id) {
                _this.getPromotion(params.id);
            }
        });
    };
    PromotionEditComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeServices();
    };
    PromotionEditComponent.prototype.getPromotion = function (uuid) {
        var _this = this;
        this.appComponent.startLoading();
        this.photosphereManager.getProducts()
            .pipe(concatMap(function (products) {
            _this.products = products;
            return _this.nurseryManager.getNurseries(true, 10000, 0)
                .pipe(concatMap(function (_a) {
                var _ = _a[0], nurseries = _a[1];
                _this.nurseries = nurseries;
                return _this.photosphereManager.getPromotion(uuid);
            }), concatMap(function (promotion) {
                _this.editedPromo = promotion;
                return _this.photosphereManager.getPromotionMedia(promotion.uuid);
            }), map(function (medias) {
                if (medias.medias && medias.medias.length > 0) {
                    var mediaURL = medias.medias[0].getMediaURL("view_fhd");
                    if (mediaURL) {
                        _this.promotionMediaUrl = mediaURL.replace("{?res}", "");
                    }
                }
            }));
        }), finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function () {
            if (_this.editedPromo && _this.editedPromo.products) {
                var prods = [];
                for (var _i = 0, _a = _this.editedPromo.products; _i < _a.length; _i++) {
                    var prod = _a[_i];
                    prods.push(prod.product);
                }
                _this.selectedItems = prods;
            }
            else {
                _this.selectedItems = [];
            }
            if (_this.editedPromo && _this.editedPromo.nurseries) {
                var nurseries = [];
                for (var _b = 0, _c = _this.editedPromo.nurseries; _b < _c.length; _b++) {
                    var nurs = _c[_b];
                    nurseries.push(nurs.nursery);
                }
                _this.selectedNurseryItems = nurseries;
            }
            else {
                _this.selectedNurseryItems = [];
            }
            var language = _this.photosphereManager.getCurrentLanguage();
            var values = {
                name: _this.editedPromo.title,
                desc: _this.editedPromo.description,
                featured: _this.editedPromo.featured,
                products: _this.selectedItems.map(function (prod) {
                    return {
                        id: prod.uuid,
                        text: _this.getProductName(prod, language)
                    };
                }),
                nurseries: _this.selectedNurseryItems.map(function (nursery) {
                    return {
                        id: nursery.uuid,
                        text: nursery.name
                    };
                }),
                image: null
            };
            for (var _d = 0, _e = _this.formInfo.fields; _d < _e.length; _d++) {
                var field = _e[_d];
                field.selectedValue = values[field.formControlName];
                if (field.formControlName === "products") {
                    field.values = _this.products.map(function (prod) {
                        return {
                            id: prod.uuid,
                            text: _this.getProductName(prod, language)
                        };
                    });
                }
                else if (field.formControlName === "nurseries") {
                    field.values = _this.nurseries.map(function (nursery) {
                        return {
                            id: nursery.uuid,
                            text: nursery.name
                        };
                    });
                }
            }
            _this.formComponent.updateFormValues(_this.formInfo);
        });
    };
    PromotionEditComponent.prototype.onSavePromotion = function () {
        var _this = this;
        this.appComponent.startLoading();
        // Products
        var oldProds = this.editedPromo.products
            ? this.editedPromo.products.map(function (prod) { return prod.product.uuid; })
            : [];
        var newProds = this.formComponent.form.value.products.map(function (prod) { return prod.id; });
        var addedProds = newProds.filter(function (prod) { return !oldProds.includes(prod); });
        var deletedProds = oldProds.filter(function (prod) { return !newProds.includes(prod); });
        // Nurseries
        var oldNurseries = this.editedPromo.nurseries
            ? this.editedPromo.nurseries.map(function (nurs) { return nurs.nursery.uuid; })
            : [];
        var newNurseries = this.formComponent.form.value.nurseries.map(function (nursery) { return nursery.id; });
        var addedNurseries = newNurseries.filter(function (nursery) { return !oldNurseries.includes(nursery); });
        var deletedNurseries = oldNurseries.filter(function (nursery) { return !newNurseries.includes(nursery); });
        this.photosphereManager.updatePromotion(this.editedPromo.uuid, {
            title: this.formComponent.form.value.name,
            description: this.formComponent.form.value.desc,
            featured: this.formComponent.form.value.featured
        }, { products: deletedProds }, { products: addedProds }, { nurseries: deletedNurseries }, { nurseries: addedNurseries }, this.selectedFiles)
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe(function () {
            _this.goToRouteByName(PRIVATE_PROMOTION_LIST_ROUTE);
        });
    };
    PromotionEditComponent.prototype.onFilesSelected = function (event) {
        var _this = this;
        this.selectedFiles = event;
        /* eslint-disable dot-notation */
        var file = this.selectedFiles["image"][0];
        /* eslint-enable dot-notation */
        var reader = new FileReader();
        reader.onload = function () { return _this.promotionMediaUrl = reader.result; };
        reader.readAsDataURL(file);
    };
    PromotionEditComponent.prototype.subscribeGenericServices = function () {
        var _this = this;
        this.onGoBackCalledSubscription = this.genericService.onGoBackCalled.subscribe(function () {
            _this.goToRouteByName(PRIVATE_PROMOTION_LIST_ROUTE);
        });
    };
    PromotionEditComponent.prototype.unsubscribeServices = function () {
        if (this.onGoBackCalledSubscription) {
            this.onGoBackCalledSubscription.unsubscribe();
        }
    };
    return PromotionEditComponent;
}(BaseComponent));
export { PromotionEditComponent };
